import React, { useState, Fragment, useEffect } from 'react';
import {
    Row,
    Input,
    Label,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Card,
    CardBody,
    CardHeader,
    CardFooter,
    Nav, TabContent, TabPane, NavItem,
} from 'reactstrap';
import { NavLink } from 'react-router-dom';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import classnames from 'classnames';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import {
    gAPI_OutboundTriggerAction_By_TriggerId,
    postAPI_Add_OutboundTriggerAction
} from '../../../../../../constants/APIs';
import WhatsAppAction from './WhatsAppAction';
import EmailAction from './EmailAction';
import Validation from '../../../../../../components/Validation';
export function TriggerAction({ visible, toggle, triggerId, LoadData }) {
    const [whatsappActionData, setWhatsappActionData] = useState([]);
    const [emailActionData, setEmailActionData] = useState([]);
    const [activeTab, setActiveTab] = useState('whatsapp');
    const [open, setOpen] = useState(false);
    const [msg, setMsg] = useState([]);
    useEffect(() => {
        if (triggerId !== undefined) {
            AxiosAPI({
                methhod: 'get',
                url: `${gAPI_OutboundTriggerAction_By_TriggerId}?triggerId=${triggerId}`,
            }).then((res) => {
                const whatsappAction = res.data.filter((k) => k.type === 'WhatsApp');
                const emailAction = res.data.filter((k) => k.type === 'Email');
                setWhatsappActionData(whatsappAction);
                setEmailActionData(emailAction);
            }).catch((err) => console.log('err', err));
        }
    }, [triggerId]);

    const toggleMenu = (tab) => {
        if (activeTab !== tab) {
            setActiveTab(tab);
        }
    };
    const toggleAction = () => {
        toggle();
    }
    const handleSubmit = (data) => {
        let body = {
            ...data,
            triggerId: triggerId,
            status: "Active",
            creator: 'dashboard',
        }
        AxiosAPI({
            method: 'post',
            url: `${postAPI_Add_OutboundTriggerAction}`,
            data: body,
        }).then((res) => {
            if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
                && res.data.Messages !== null && res.data.Messages.length > 0) {
                setMsg(res.data.Messages);
                setOpen(true);
            }
            else {
                toggleAction();
                LoadData();
            }
        }).catch((err) => {
            console.log('err', err);
        });
    };
    return (
        <Fragment>
            <Modal isOpen={visible} toggle={toggleAction} size="lg">
                <ModalHeader toggle={toggleAction}>Add Trigger Actions</ModalHeader>
                <Row>
                    <Colxx xxs="12">
                        <Nav tabs className="card-header-tabs ml-0 mr-0">
                            <NavItem className="w-50 text-center">
                                <NavLink
                                    className={classnames({
                                        active: activeTab === "whatsapp",
                                        "nav-link": true
                                    })}
                                    onClick={() => {
                                        toggleMenu("whatsapp");
                                    }}
                                    to="#"
                                >
                                    WhatsApp
                                </NavLink>
                            </NavItem>
                            <NavItem className="w-50 text-center">
                                <NavLink
                                    className={classnames({
                                        active: activeTab === "email",
                                        "nav-link": true
                                    })}
                                    onClick={() => {
                                        toggleMenu("email");
                                    }}
                                    to="#"
                                >
                                    Email
                                </NavLink>
                            </NavItem>
                        </Nav>
                        <TabContent activeTab={activeTab}>
                            <TabPane tabId="whatsapp">
                                <div className="pt-2 pr-2 pl-2">
                                    <WhatsAppAction
                                        inputData={whatsappActionData}
                                        submit={handleSubmit}
                                        toggle={toggleAction}
                                    ></WhatsAppAction>
                                </div>
                            </TabPane>
                        </TabContent>
                        <TabContent activeTab={activeTab} >
                            <TabPane tabId="email">
                                <div className="pt-2 pr-2 pl-2">
                                    <EmailAction
                                        inputData={emailActionData}
                                        submit={handleSubmit}
                                        toggle={toggleAction}></EmailAction>
                                </div>
                            </TabPane>
                        </TabContent>
                    </Colxx>
                </Row>

            </Modal>
            <Validation open={open} messages={msg} toggle={() => { setOpen(!open) }}></Validation>
        </Fragment>
    );
}